/*
 * Cart drawer (ZonaDental)
 * -------------------------------------------------------------
 * Panel lateral del carrito. Se actualiza con la Section Rendering API
 * (sections/cart-drawer.liquid) para que Liquid calcule siempre los
 * descuentos correctamente (ofertas compare_at + descuentos del carrito).
 *
 * Se controla con las opciones globales de "Carrito":
 *   window.enable_cart_drawer          -> abre el drawer al agregar / al clic en el ícono
 *   window.disable_cart_redirect       -> evita la redirección a /cart al agregar
 *   window.disable_cart_drawer_autoopen -> no abre el drawer solo al agregar (sí al clic en el ícono)
 */
(function () {
  'use strict';

  var SECTION_ID = 'cart-drawer';
  var SECTION_WRAPPER_ID = 'shopify-section-' + SECTION_ID;
  var OPEN_CLASS = 'show-cart-sidebar';

  function drawerEnabled() {
    return window.enable_cart_drawer === true || window.enable_cart_drawer === 'true';
  }

  function redirectDisabled() {
    return window.disable_cart_redirect === true || window.disable_cart_redirect === 'true';
  }

  /* Cuando está activo, el drawer NO se abre solo al agregar un producto
     (settings.disable_cart_drawer_autoopen). Sigue abriéndose al hacer clic
     en el ícono del carrito. El contenido se refresca igual para mantener
     sincronizado el contador. */
  function autoOpenDisabled() {
    return window.disable_cart_drawer_autoopen === true || window.disable_cart_drawer_autoopen === 'true';
  }

  function getWrapper() {
    return document.getElementById(SECTION_WRAPPER_ID);
  }

  /* ------------------------------------------------------------------ */
  /* Aplica la configuración del bloque de carrito (header-cart-block)   */
  /* al drawer: título, subtotal, botones. Se define en                 */
  /* window.zdCartDrawerConfig desde snippets/header-cart-block.liquid.  */
  /* ------------------------------------------------------------------ */
  function toggleEl(el, show) {
    if (!el) return;
    el.style.display = show === false ? 'none' : '';
  }

  function applyConfig() {
    var root = getWrapper();
    if (!root) return;

    var cfg = window.zdCartDrawerConfig;

    /* Botón "Ver carrito": lo controla la opción del tema
       settings.show_cart_drawer_viewcart (window.show_cart_drawer_viewcart).
       Si esa opción no está definida, cae a la config del bloque del header
       (compatibilidad); por defecto se muestra. Se resuelve aquí, antes del
       guard de cfg, para que funcione aunque el bloque no exista. */
    var showViewCart = true;
    if (typeof window.show_cart_drawer_viewcart !== 'undefined') {
      showViewCart = window.show_cart_drawer_viewcart === true || window.show_cart_drawer_viewcart === 'true';
    } else if (cfg && typeof cfg.showViewCart !== 'undefined') {
      showViewCart = cfg.showViewCart;
    }
    toggleEl(root.querySelector('[data-drawer-viewcart]'), showViewCart);

    if (!cfg) return;

    if (cfg.title) {
      var titleEl = root.querySelector('.zd-cart-drawer__title-text');
      if (titleEl) titleEl.textContent = cfg.title;
    }
    toggleEl(root.querySelector('.zd-cart-drawer__row--subtotal'), cfg.showSubtotal);
    toggleEl(root.querySelector('[data-drawer-checkout]'), cfg.showCheckout);
  }

  /* ------------------------------------------------------------------ */
  /* Abrir / cerrar                                                      */
  /* ------------------------------------------------------------------ */
  function openDrawer() {
    document.body.classList.add(OPEN_CLASS);
  }

  function closeDrawer() {
    document.body.classList.remove(OPEN_CLASS);
  }

  /* ------------------------------------------------------------------ */
  /* Respaldo: baja temporalmente los widgets flotantes de apps (p. ej.  */
  /* el botón de WhatsApp) que usan un z-index al tope y podrían quedar   */
  /* por encima del drawer. Se restauran al cerrar.                      */
  /* ------------------------------------------------------------------ */
  var floatSuppressed = [];

  function suppressFloating() {
    if (floatSuppressed.length) return;
    var nodes = document.querySelectorAll('body *');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.closest && el.closest('#' + SECTION_WRAPPER_ID)) continue;
      var cs = window.getComputedStyle(el);
      if (cs.position !== 'fixed' && cs.position !== 'sticky') continue;
      var z = parseInt(cs.zIndex, 10);
      if (!isNaN(z) && z >= 2147483000) {
        floatSuppressed.push([el, el.style.zIndex]);
        el.style.setProperty('z-index', '1', 'important');
      }
    }
  }

  function restoreFloating() {
    for (var i = 0; i < floatSuppressed.length; i++) {
      var el = floatSuppressed[i][0];
      var prev = floatSuppressed[i][1];
      if (prev) {
        el.style.zIndex = prev;
      } else {
        el.style.removeProperty('z-index');
      }
    }
    floatSuppressed = [];
  }

  /* ------------------------------------------------------------------ */
  /* Actualizar el contenido del drawer vía Section Rendering API        */
  /* ------------------------------------------------------------------ */
  var refreshing = false;

  /* Carga de productos recomendados dentro del drawer */
  function loadCartRecommendations() {
    var recContainer = document.getElementById('zd-cart-recommendations');
    var firstCartItem = document.querySelector('.zd-cart-item');
    if (!recContainer || !firstCartItem) {
      if (recContainer) recContainer.innerHTML = '';
      return;
    }
    
    // Obtenemos el product_id del enlace de la primera linea, 
    // pero de forma nativa Shopify Product Recommendations API también necesita un ID.
    // Lo más facil en Liquid JS es extraer el key o URL y buscar el product ID,
    // o podemos meterlo en un atributo de .zd-cart-item en cart-drawer.liquid.
    var productId = firstCartItem.getAttribute('data-product-id');
    if (!productId) return;

    var sectionId = 'cart-drawer-recommendations';
    var url = window.routes ? (window.routes.product_recommendations_url || '/recommendations/products') : '/recommendations/products';
    url += '?section_id=' + sectionId + '&product_id=' + productId + '&limit=6&intent=related';

    fetch(url)
      .then(function(res) { return res.text(); })
      .then(function(html) {
        var dummy = document.createElement('div');
        dummy.innerHTML = html;
        var recWrapper = dummy.querySelector('.zd-cart-recommendations-wrapper');
        
        if (recWrapper) {
          recContainer.innerHTML = recWrapper.outerHTML;
          
          // Si hay scripts dentro (como el form listener), eval() o re-vincular
          var scripts = recContainer.querySelectorAll('script');
          scripts.forEach(function(s) {
            var newScript = document.createElement('script');
            newScript.textContent = s.textContent;
            document.body.appendChild(newScript);
            newScript.parentNode.removeChild(newScript);
          });
        } else {
          // Fallback if the section is missing (e.g. not published to live theme)
          recContainer.innerHTML = '';
        }
      })
      .catch(function(e) { console.warn('Error loading recommendations', e); });
  }

  /* Inserta el HTML del drawer ya renderizado y sincroniza contador/config */
  function renderDrawer(html) {
    var wrapper = getWrapper();
    if (!wrapper || typeof html !== 'string') return false;
    wrapper.innerHTML = html;
    syncCartCount();
    applyConfig();
    loadCartRecommendations();
    return true;
  }

  function refreshDrawer(callback) {
    var wrapper = getWrapper();
    if (!wrapper) {
      if (callback) callback();
      return;
    }
    refreshing = true;
    fetch('/?sections=' + SECTION_ID, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data && typeof data[SECTION_ID] === 'string') {
          renderDrawer(data[SECTION_ID]);
        }
      })
      .catch(function () {})
      .then(function () {
        refreshing = false;
        if (callback) callback();
      });
  }

  /* Sincroniza los contadores del ícono del carrito en el header */
  function syncCartCount() {
    var root = document.querySelector('.zd-cart-drawer');
    if (!root) return;
    var count = root.getAttribute('data-cart-count');
    if (count === null) return;
    document.querySelectorAll('.minicart-header .cout_item, #scartcount').forEach(function (el) {
      el.textContent = count;
    });
    document.querySelectorAll('.minicart-header').forEach(function (mc) {
      if (parseInt(count, 10) > 0) {
        mc.classList.remove('empty');
      } else {
        mc.classList.add('empty');
      }
    });
  }

  /* ------------------------------------------------------------------ */
  /* Cambiar cantidad / eliminar línea (/cart/change.js con sections)     */
  /* Una sola petición que devuelve el HTML del drawer ya renderizado.    */
  /* Cada línea se bloquea mientras su cambio está en curso: así los       */
  /* clics rápidos en "+" no pueden superar el stock (cada incremento      */
  /* se confirma con el servidor antes de permitir el siguiente).          */
  /* ------------------------------------------------------------------ */
  var busyKeys = {};

  function changeUrl() {
    return (window.routes && window.routes.cart_change_url ? window.routes.cart_change_url : '/cart/change') + '.js';
  }

  function isBusy(key) {
    return busyKeys[key] === true;
  }

  /* Envía el cambio y refresca el drawer en una sola llamada.
     force = true ignora el bloqueo (para eliminar una línea). */
  function commitChange(key, quantity, qtyWrap, force) {
    if (!force && isBusy(key)) return;
    busyKeys[key] = true;
    if (qtyWrap) qtyWrap.classList.add('is-busy');

    fetch(changeUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: key,
        quantity: quantity,
        sections: SECTION_ID,
        sections_url: window.location.pathname
      })
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        busyKeys[key] = false;
        var wrapper = getWrapper();
        if (data && data.sections && typeof data.sections[SECTION_ID] === 'string' && wrapper) {
          wrapper.innerHTML = data.sections[SECTION_ID];
          syncCartCount();
          applyConfig();
          loadCartRecommendations();
        } else {
          refreshDrawer();
        }
      })
      .catch(function () {
        busyKeys[key] = false;
        refreshDrawer();
      });
  }

  /* ------------------------------------------------------------------ */
  /* Delegación de eventos                                               */
  /* ------------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    /* Abrir el drawer al hacer clic en el ícono del carrito */
    var toggle = e.target.closest('.js-cart-toggle');
    if (toggle && drawerEnabled()) {
      e.preventDefault();
      openDrawer();
      refreshDrawer();
      return;
    }

    /* Cerrar */
    if (e.target.closest('[data-action="close-minicart"]')) {
      e.preventDefault();
      closeDrawer();
      return;
    }

    /* Eliminar línea (inmediato, con feedback optimista) */
    var removeBtn = e.target.closest('[data-remove]');
    if (removeBtn) {
      e.preventDefault();
      var itemRemove = removeBtn.closest('.zd-cart-item');
      if (itemRemove) {
        itemRemove.classList.add('is-removing');
        commitChange(itemRemove.getAttribute('data-key'), 0, null, true);
      }
      return;
    }

    /* Botones +/- de cantidad */
    var qtyBtn = e.target.closest('[data-qty-change]');
    if (qtyBtn) {
      e.preventDefault();
      var line = qtyBtn.closest('.zd-cart-item');
      if (!line) return;
      var key = line.getAttribute('data-key');
      var qtyWrap = line.querySelector('.zd-cart-item__qty');

      /* "+" deshabilitado (sin más stock): solo feedback, sin petición */
      if (qtyBtn.disabled || qtyBtn.classList.contains('is-disabled')) {
        flagMaxReached(line);
        return;
      }

      /* Cambio en curso para esta línea: ignoramos el clic rápido.
         Cada incremento se confirma con el servidor antes del siguiente,
         por eso no se puede superar el stock. */
      if (isBusy(key)) {
        flagMaxReached(line);
        return;
      }

      var input = line.querySelector('[data-qty-input]');
      var current = parseInt(input.value, 10) || 1;
      var isPlus = qtyBtn.getAttribute('data-qty-change') === 'plus';
      var next = isPlus ? current + 1 : current - 1;
      if (next < 0) next = 0;
      if (next === current) return;
      input.value = next; /* actualización optimista: responde al instante */
      commitChange(key, next, qtyWrap);
      return;
    }
  });

  /* Feedback breve (parpadeo) sin exponer cantidades */
  function flagMaxReached(item) {
    item.classList.add('is-max-reached');
    setTimeout(function () { item.classList.remove('is-max-reached'); }, 500);
  }

  /* Cantidad escrita manualmente */
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-qty-input]');
    if (!input) return;
    var line = input.closest('.zd-cart-item');
    if (!line) return;
    var key = line.getAttribute('data-key');
    if (isBusy(key)) return;
    var qty = parseInt(input.value, 10);
    if (isNaN(qty) || qty < 0) qty = 0;
    commitChange(key, qty, line.querySelector('.zd-cart-item__qty'));
  });

  /* Cerrar con la tecla Escape */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && document.body.classList.contains(OPEN_CLASS)) {
      closeDrawer();
    }
  });

  /* ------------------------------------------------------------------ */
  /* Detectar cuando se agrega un producto (/cart/add) para refrescar    */
  /* y abrir el drawer. No inicia peticiones: solo observa las que ya    */
  /* hace el tema (bs_app.js, product-form.js, etc.).                    */
  /* ------------------------------------------------------------------ */
  function isCartAdd(url) {
    if (!url) return false;
    if (typeof url !== 'string' && url.url) url = url.url;
    return typeof url === 'string' && url.indexOf('/cart/add') !== -1;
  }

  /* Se llama al confirmarse un /cart/add. Abre el drawer YA y, si la
     respuesta del add ya trae el HTML de la sección (parámetro sections),
     lo usa directamente = una sola petición, sin retardo. Si no, hace el
     fallback de traer la sección aparte. */
  /* Abre el drawer en el siguiente frame. El doble requestAnimationFrame deja
     que el navegador PINTE primero el panel recién insertado en su estado
     cerrado (translateX(100%)); al añadir la clase después, la transición
     corre suave en vez de aparecer de golpe. */
  function openSmooth() {
    if (!drawerEnabled()) return;
    if (autoOpenDisabled()) return;
    requestAnimationFrame(function () {
      requestAnimationFrame(openDrawer);
    });
  }

  /* ------------------------------------------------------------------ */
  /* Mensaje "Agregado al carrito" sobre la product card                 */
  /* Al agregar desde una card: oscurece la imagen con el texto, y solo   */
  /* tras ocultarse el mensaje se abre el drawer.                         */
  /* ------------------------------------------------------------------ */
  var CARD_MSG_MS = 1100;  // duración del mensaje sobre la card
  var CARD_MSG_GAP = 200;  // pausa tras ocultarse antes de abrir el drawer
  var pendingCardImg = null;
  var pendingCardAt = 0;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.product-item .action-to-cart') : null;
    if (!btn) return;
    if (btn.getAttribute && btn.getAttribute('disabled') === 'disabled') return;
    var item = btn.closest('.product-item');
    var img = item ? item.querySelector('.product-image') : null;
    if (!img) return;
    if (!img.closest('.product-grid')) return; // solo cards del grid (donde existe el overlay)
    img.classList.add('zd-added');
    pendingCardImg = img;
    pendingCardAt = Date.now();
    setTimeout(function () { img.classList.remove('zd-added'); }, CARD_MSG_MS);
  }, true);

  function onProductAdded(responseText) {
    var html = null;
    if (responseText) {
      try {
        var json = JSON.parse(responseText);
        if (json && json.sections && typeof json.sections[SECTION_ID] === 'string') {
          html = json.sections[SECTION_ID];
        }
      } catch (e) {}
    }

    /* Si el producto se agregó desde una product card, esperamos a que el
       mensaje "Agregado al carrito" termine antes de abrir el drawer. */
    var open = openSmooth;
    if (pendingCardImg) {
      var elapsed = Date.now() - pendingCardAt;
      var wait = Math.max(0, CARD_MSG_MS - elapsed) + CARD_MSG_GAP;
      pendingCardImg = null;
      open = function () { setTimeout(openSmooth, wait); };
    }

    /* Renderizamos el contenido ANTES de abrir para que el panel parta de su
       posición cerrada y la animación de entrada se vea completa. */
    if (html) {
      renderDrawer(html);
      open();
    } else {
      refreshDrawer(open);
    }
  }

  /* fetch */
  if (window.fetch) {
    var _fetch = window.fetch;
    window.fetch = function () {
      var isAdd = isCartAdd(arguments[0]);
      var res = _fetch.apply(this, arguments);
      if (isAdd) {
        res.then(function (r) {
          if (!r || !r.ok) return;
          /* Clonamos para leer el cuerpo sin afectar a quien hizo el fetch */
          r.clone().text().then(function (txt) { onProductAdded(txt); }).catch(function () { onProductAdded(); });
        }).catch(function () {});
      }
      return res;
    };
  }

  /* XMLHttpRequest (jQuery.ajax de bs_app.js usa esto) */
  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._zdIsCartAdd = isCartAdd(url);
    return _open.apply(this, arguments);
  };
  var _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (this._zdIsCartAdd) {
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) onProductAdded(this.responseText);
      });
    }
    return _send.apply(this, arguments);
  };

  /* ------------------------------------------------------------------ */
  /* Formularios nativos de "Agregar al carrito" (p. ej. el del PDP).     */
  /* Ese <form action="/cart/add" method="post"> hace un POST nativo que, */
  /* por defecto, RECARGA la página y redirige a /cart. Como no pasa por  */
  /* fetch/XHR, los interceptores de arriba no lo ven: el drawer no se     */
  /* abre y la opción "Desactivar redirección" no surte efecto.           */
  /* Aquí lo interceptamos y lo reenviamos por fetch: así el interceptor   */
  /* de /cart/add de este mismo script abre el drawer (si está activo) y   */
  /* nunca se produce la redirección. Solo intervenimos si hay que abrir   */
  /* el drawer o evitar la redirección; si no, dejamos el envío nativo.    */
  /* ------------------------------------------------------------------ */
  function cartAddUrl() {
    return (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js';
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.nodeName !== 'FORM') return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    if (!drawerEnabled() && !redirectDisabled()) return;
    if (!window.fetch) return; // sin fetch: dejamos el envío nativo (redirige)

    e.preventDefault();

    var formData = new FormData(form);
    /* Pedimos el HTML del drawer en la misma respuesta para abrirlo sin
       una segunda petición (el interceptor de fetch lo detecta y renderiza). */
    formData.append('sections', SECTION_ID);
    formData.append('sections_url', window.location.pathname);

    fetch(cartAddUrl(), {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    }).catch(function () {});
  }, false);

  /* Observa la apertura/cierre del drawer (venga de este script o de
     bs_app.js) para bajar/restaurar los widgets flotantes de apps. */
  if (window.MutationObserver) {
    var mo = new MutationObserver(function () {
      if (document.body.classList.contains(OPEN_CLASS)) {
        suppressFloating();
      } else {
        restoreFloating();
      }
    });
    mo.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  /* Sincroniza el contador y aplica la configuración del bloque al cargar */
  document.addEventListener('DOMContentLoaded', function () {
    syncCartCount();
    applyConfig();
  });
})();
